/* eslint-disable @typescript-eslint/no-explicit-any */
import { STRINGS } from 'config';
import { pulseRhythmCodes, vitalCodeMap } from 'model/toolbar/snomed';

const {
  REDUCERS: {
    SNOMED: {
      SET_VITAL,
      RESET_SNOMED,
      TOGGLE_SELECTED_SNOMED,
      SET_PROBLEM_SNOMED_CODE,
      AI_SNOMED_REQUEST_PENDING,
      AI_SNOMED_REQUEST_SUCCESS,
      AI_SNOMED_REQUEST_FAILED,
    },
  },
  REQUEST_STATUS: { IDLE, PENDING, SUCCEEDED },
} = STRINGS;

export interface Vitals {
  height: number | null;
  weight: number | null;
  pulseRate: number | null;
  tympanicTemperature: number | null;
  peakFlowRate: number | null;
  systolic: number | null;
  diastolic: number | null;
  bmi: number | null;
  pulseRhythm: string | null;
}

export interface AiSnomedEntry {
  code: string;
  info: string;
  unit: string | null;
  value: string | null;
}
export interface SnomedState {
  vitals: Vitals;
  selectedSnomed: string[];
  aiSnomedCodes: null | AiSnomedEntry[];
  aiSnomedFetchStatus: string;
  problemSnomed: AiSnomedEntry | null;
}

export const initialSnomedState: SnomedState = {
  vitals: {
    systolic: null,
    diastolic: null,
    height: null,
    weight: null,
    pulseRate: null,
    tympanicTemperature: null,
    peakFlowRate: null,
    bmi: null,
    pulseRhythm: null,
  },
  selectedSnomed: [],
  aiSnomedCodes: null,
  aiSnomedFetchStatus: IDLE,
  problemSnomed: null,
};

export const snomedReducer = (state: any, action: any): SnomedState => {
  switch (action.type) {
    case SET_VITAL: {
      const { key, val } = action.payload;
      const entry = Object.entries(vitalCodeMap).find(([k]) => k === key);
      const vitalCode = entry?.[1].code;
      const hasValueAlready = !!state?.vitals[key];
      let selectedSnomed = [...state.selectedSnomed];
      if (key === 'pulseRhythm') {
        selectedSnomed = [
          ...state.selectedSnomed.filter(
            (code: string) => !Object.keys(pulseRhythmCodes).map(Number).includes(Number(code)),
          ),
        ];
        if (val) {
          selectedSnomed.push(val);
        }
      } else {
        if (!hasValueAlready && vitalCode && !selectedSnomed.includes(vitalCode)) {
          selectedSnomed.push(vitalCode);
        }
        if (!val) {
          selectedSnomed = [...state.selectedSnomed.filter((code: string) => code !== vitalCode)];
        }
      }
      return {
        ...state,
        vitals: {
          ...state.vitals,
          [key]: val,
        },
        selectedSnomed,
      };
    }
    case TOGGLE_SELECTED_SNOMED: {
      const code = action.payload.code as string;
      const already = state.selectedSnomed.includes(code);
      return {
        ...state,
        selectedSnomed: already
          ? state.selectedSnomed.filter((c: string) => c !== code)
          : [...state.selectedSnomed, code],
      };
    }
    case RESET_SNOMED: {
      return initialSnomedState;
    }
    case AI_SNOMED_REQUEST_PENDING: {
      return { ...state, aiSnomedFetchStatus: PENDING };
    }
    case AI_SNOMED_REQUEST_SUCCESS: {
      // Only update if the request is still pending (not cancelled by reset)
      if (state.aiSnomedFetchStatus !== PENDING) {
        return state;
      }
      return { ...state, aiSnomedCodes: action.payload, aiSnomedFetchStatus: SUCCEEDED };
    }
    case AI_SNOMED_REQUEST_FAILED: {
      return { ...state, aiSnomedFetchStatus: IDLE };
    }
    case SET_PROBLEM_SNOMED_CODE: {
      return { ...state, problemSnomed: action.payload };
    }
    default: {
      return state;
    }
  }
};
